import React from 'react';
import { t } from '../lib/i18n';
import { Check, ShoppingCart, Hammer, Sofa, Shirt, Smartphone, Tv, Sparkles, Gem, Dumbbell, Flower2, Baby, PawPrint, UtensilsCrossed, Car, Snowflake, BadgePercent, Tag } from 'lucide-react';

const iconMap = {
  ShoppingCart, Hammer, Sofa, Shirt, Smartphone, Tv, Sparkles, Gem,
  Dumbbell, Flower2, Baby, PawPrint, UtensilsCrossed, Car, Snowflake, BadgePercent, Tag
};

const CategoryPicker = ({ categories = [], selected, onToggle, onValidate }) => {
  return (
    <div className="py-6" data-testid="category-picker">
      <div className="text-center mb-6">
        <h2 className="text-xl font-bold text-white mb-2">
          {t('Quels sont vos centres d\'intérêt ?')}
        </h2>
        <p className="text-sm text-[#808080]">
          Sélectionnez les catégories qui vous intéressent pour personnaliser vos catalogues.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-6">
        {categories.map((cat) => {
          const isSelected = selected.includes(cat.slug);
          const Icon = iconMap[cat.icon] || Tag;
          return (
            <button
              key={cat.id}
              onClick={() => onToggle(cat.slug)}
              data-testid={`interest-${cat.slug}`}
              className={`relative flex flex-col items-center gap-2 p-4 rounded-lg border transition-all duration-200 ${
                isSelected
                  ? 'border-[#E50914] bg-[#E50914]/10 shadow-[0_0_15px_rgba(229,9,20,0.2)]'
                  : 'border-[#262626] bg-[#141414] hover:border-[#808080] hover:bg-[#181818]'
              }`}
            >
              {isSelected && (
                <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-[#E50914] flex items-center justify-center">
                  <Check size={12} className="text-white" />
                </div>
              )}
              {Icon && (
                <Icon
                  size={24}
                  className={isSelected ? 'text-[#E50914]' : 'text-[#808080]'}
                />
              )}
              <span className={`text-xs font-medium text-center leading-tight ${
                isSelected ? 'text-white' : 'text-[#B3B3B3]'
              }`}>
                {cat.name}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex justify-center">
        <button
          onClick={onValidate}
          disabled={selected.length === 0}
          data-testid="validate-interests-btn"
          className={`px-8 py-3 rounded-sm font-bold text-sm transition-all duration-200 active:scale-95 ${
            selected.length > 0
              ? 'bg-[#E50914] text-white hover:bg-[#F40612] shadow-lg shadow-[#E50914]/20'
              : 'bg-[#262626] text-[#808080] cursor-not-allowed'
          }`}
        >
          {`Afficher mes catalogues (${selected.length} catégorie${selected.length !== 1 ? 's' : ''})`}
        </button>
      </div>
    </div>
  );
};

export default CategoryPicker;
